import { ApplicationModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { saga } from "./saga";

export const customActionsModule: ApplicationModule<typeof NAME> = {
    NAME,
    saga,
};
